module.exports = __webpack_public_path__ + "img/target_pin_red.a37bd002.svg";